module.exports = __webpack_public_path__ + "img/dreams-app-icon.f2bc29c.png";